import React from "react";

import styles from './HeaderMobile.module.css';
import {Phone} from "@/widgets/Phone/Phone.tsx";
import { Logo } from "@/widgets/Logo/Logo.tsx";
import {SearchBar} from "@/widgets/SearchBar/SearchBar.tsx";
import {Wrapper} from "@/ui/General/Wrapper/Wrapper.tsx";
import {Geolocation} from "@/widgets/Geolocation/Geolocation.tsx";
import {Delivery} from "@/widgets/Delivery/Delivery.tsx";

export const HeaderMobile: React.FC = () => {
    return (
        <>
            <Wrapper bgColor='#e3e3e3' containerClassName={styles.topContent}>
                <Geolocation />
                <Delivery />
            </Wrapper>

            <Wrapper bgColor='#eee' containerClassName={styles.bottomContent}>
                <div>
                    <Logo/>
                    <Phone numberClassName={styles.phone}/>
                </div>
                <div className={styles.fixed}>
                    <SearchBar
                        isMobile
                        placeholder='Искать по названию, артикулу или номеру детали'
                        className={styles.searchBar}
                    />
                </div>
            </Wrapper>
        </>
    )
}
